module.exports = __webpack_public_path__ + "img/changguiyou_pic.329027ee.jpg";